import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'portal.components.achievementDisplay.title',
    defaultMessage: 'Certificates',
    description: 'Default title for certificates section',
  },
});

export default messages;
